import { render, staticRenderFns } from "./FeedbackSubmit.vue?vue&type=template&id=6039ca3c"
import script from "./FeedbackSubmit.vue?vue&type=script&lang=js"
export * from "./FeedbackSubmit.vue?vue&type=script&lang=js"
import style0 from "./FeedbackSubmit.vue?vue&type=style&index=0&id=6039ca3c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports